import React from 'react'
import boothcoatingq from "../assets/img/vacspl/boothcoating1.jpeg"
import configs from "./configs.js";


const HeadPdf = (props) => {

    let {formdata} = props

    const getname = (key)=>{
         let obj = configs.clientFornInputsArr.find(item=>item.key === key)
         if(obj){
            return obj.value
         } else{
            return ""
         }
    }
    const getnameService = (key)=>{
        let obj = configs.vacsplFornInputsArr.find(item=>item.key === key)
        if(obj){
           return obj.value
        } else{
           return ""
        }
   }

    // const client = {
    //     name: "Hero Moto Cop Pvt Ltd",
    //     address: "Gajrola, Gujrat",
    //     contactPerson: "Mr. Alit Tyagi",
    //     mobile: "7826543323",
    //     email: "anittyabjd@gmail.com"
    // }
    // const engineer = {
    //     name: "Manoj Rawat",
    //     mobile: "7826543323",
    //     email: "manojwatwe@optifinish.in"
    // }
    return (
        <div className='pdfhead'>
            <div className='pdfheadImg'>
                <img src={boothcoatingq} alt='headingpage'/>
            </div>
            <h3 className='heading'>Plant Inspection Report <br /> by <br /> Value Added Coating Solution Pvt Ltd.</h3>
            <div className='section pm10'>
                <div className='section-head'>Client/ Company Details:</div>
                <div className='details'>
                    {Object.keys(formdata).map((key) => {
                        let name = getname(key);
                        if (name) {
                            return (
                                <div className='keyValue'>
                                    <div className='key1'>{name}</div>
                                    <div className='value'>{formdata[key]}</div>
                                </div>
                            )
                        } else return null
                    })}
                </div>

            </div>

            <div className='section pm10'>
                <div className='section-head'>Service Engineer Details:</div>
                <div className='details'>
                {Object.keys(formdata).map((key) => {
                        let name = getnameService(key);
                        if (name) {
                            return (
                                <div className='keyValue'>
                                    <div className='key1'>{name}</div>
                                    <div className='value'>{formdata[key]}</div>
                                </div>
                            )
                        } else return null
                    })}
                </div>

            </div>
        </div>
    )
}

export default HeadPdf